import { generatePalette } from './generatePalette';

const primary = process.env.REACT_APP_PRIMARY_COLOR || '#233AC6';
const secondary = process.env.REACT_APP_SECONDARY_COLOR || '#f5f7f9';
const neutral = '#808080';
const red = '#ff0000';
const yellow = '#ffff00';
const blue = '#3B82F6';
const green = '#00ff00';
const white = '#ffffff';
const black = '#000000';

const PRIMARY_PALETTE = generatePalette(primary);
const SECONDARY_PALETTE = generatePalette(secondary);
const NEUTRAL_PALETTE = generatePalette(neutral);
const RED_PALETTE = generatePalette(red);
const YELLOW_PALETTE = generatePalette(yellow);
const BLUE_PALETTE = generatePalette(blue);
const GREEN_PALETTE = generatePalette(green);

export const COLORS = {
    red,
    yellow,
    blue,
    green,
    white,
    black,
};

export const COLOR_PALETTE = {
    primary: PRIMARY_PALETTE,
    secondary: SECONDARY_PALETTE,
    neutral: NEUTRAL_PALETTE,
    red: RED_PALETTE,
    yellow: YELLOW_PALETTE,
    blue: BLUE_PALETTE,
    green: GREEN_PALETTE,
};
